﻿import React, { useState } from 'react';
import { Asset } from '../models/asset';
import { PWDates } from '../utilities/pw-dates';
import { Tooltip } from 'devextreme-react/tooltip';

export interface Props {
    target: string | HTMLElement | undefined | null;
    instrument?: Asset;
}

export default function InstrumentSelectBoxTooltip(props: Props) {
    let revalidationDateCss = "date-good";

    if (props.instrument &&
        props.instrument.revalidationDate) {
        revalidationDateCss = getValidationDateColor(props.instrument.revalidationDate);
    }

    return (
        <>
            {props.instrument &&
                <Tooltip
                    target={props.target}
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    hideOnOutsideClick={false}
                >
                    <>
                        <div>
                            <div className="pw-form-unit-label">Asset Number</div>
                            <div className="pw-readonly-label">{props.instrument?.formattedAssetNumber
                                ?? props.instrument?.assetNumber ?? 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Asset Name</div>
                            <div className="pw-readonly-label">{props.instrument.assetName ?
                                props.instrument.assetName : 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Revalidation Date</div>
                            <div className={`pw-readonly-label ${revalidationDateCss}`}>
                                {props.instrument && props.instrument.revalidationDate ? PWDates.getDateString(props.instrument.revalidationDate) : 'NA'}
                            </div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Description</div>
                            <div className="pw-readonly-label">{props.instrument && props.instrument.description ?
                                props.instrument.description : 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Model Number</div>
                            <div className="pw-readonly-label">{props.instrument && props.instrument.modelNumber ?
                                props.instrument.modelNumber : 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Serial Number</div>
                            <div className="pw-readonly-label">{props.instrument && props.instrument.vendorSerialNumber ?
                                props.instrument.vendorSerialNumber : 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Zone</div>
                            <div className="pw-readonly-label">{props.instrument.zoneLocation ?
                                props.instrument.zoneLocation : 'NA'}</div>
                        </div>
                        <div>
                            <div className="pw-form-unit-label">Bin</div>
                            <div className="pw-readonly-label">{props.instrument.binLocation ?
                                props.instrument.binLocation : 'NA'}</div>
                        </div>
                    </>
                </Tooltip >
            }
        </>
    );

    function getValidationDateColor(d: Date) {
        let now = new Date();
        let date = new Date(d);

        if (date.getTime() < now.getTime()) {
            return "date-expired";
        }

        const inOneMonth = new Date(now.setMonth(now.getMonth() + 1));

        if (date.getTime() < inOneMonth.getTime())
            return "date-warning";
        else
            return "date-good";
    }
}

